import React, { useMemo, FC } from 'react'
import { Card } from 'transfix-ui/components/Card'
import { Box, Typography, makeStyles } from 'transfix-ui/core'
import { IShipment } from 'types'
import { Bullet } from 'components/atoms'
import { formatPerMile } from 'utils/formatCurrency'
import DISPLAY from 'constants/display'
import { EQUIPMENT_ICON_MAP } from 'constants/equipmentConstants'
import { MarketplaceStopConfirmation } from '../marketplace/stops/MarketplaceStopConfirmation'

export const useLoadDetailStyles = makeStyles(theme => ({
  card: {
    padding: 24,
    [theme.breakpoints.up('md')]: {
      position: 'sticky',
      top: theme.spacing(4),
    },
  },
}))

export interface ILoadDetailProps {
  shipment: IShipment
  showListRateOverride?: boolean
}

export const LoadDetail: FC<ILoadDetailProps> = ({ shipment, showListRateOverride = false }) => {
  const classes = useLoadDetailStyles()

  const { bids, carrierPayment, equipment, id: shipmentId, info, stops } = shipment || {}
  const { parentKey } = equipment || {}

  const counteredBid = useMemo(() => bids?.find(b => b.status === 'countered'), [bids])
  const { carrierRate, targetCarrierRate } = carrierPayment || {}

  // Show proposed counter bid, an accepted bid, or the list rate
  const rate = showListRateOverride
    ? carrierRate || targetCarrierRate
    : counteredBid?.counterBidAmount || carrierRate || targetCarrierRate

  const parentKeyEquipment = useMemo(() => EQUIPMENT_ICON_MAP.find(p => p.key === parentKey), [
    parentKey,
  ])

  const { totalMiles, totalPalletCount, totalWeight } = info || {}

  return (
    <Card className={classes.card}>
      <Typography variant='overline'>LOAD #TFX-{shipmentId}</Typography>
      <Box my={3}>
        <Box>
          <Typography variant='h3' component='span'>
            ${Math.floor(parseInt(rate || '', 10))}
          </Typography>
          <Typography variant='subtitle1' color='textSecondary' component='span'>
            {' '}
            ${formatPerMile(rate, parseFloat(totalMiles), true) || 0}/mi
          </Typography>
        </Box>
        <Box mt={1}>
          <Typography variant='subtitle1' component='span'>
            {totalMiles} mi
          </Typography>
          <Bullet />
          <Typography variant='subtitle1' component='span'>
            {parentKeyEquipment?.name}
          </Typography>
          <Bullet />
          <Typography variant='subtitle1' component='span'>
            {totalWeight ? totalWeight.toLocaleString() : DISPLAY.empty} lbs
          </Typography>
          <Bullet />
          <Typography variant='subtitle1' component='span'>
            {totalPalletCount || DISPLAY.empty} total pallet
            {parseInt(totalPalletCount, 10) === 1 ? '' : 's'}
          </Typography>
        </Box>
      </Box>
      <MarketplaceStopConfirmation stops={stops} compact />
    </Card>
  )
}
